/**
 * Created by benjamincoumes on 1/18/17.
 */
import HelpDeskApi from '../api/helpDeskApi';
import * as types from './actionTypes';
import {startAjaxCall, startAjaxCallError} from './ajaxStatusActions'; //eslint-disable-line no-unused-vars

export function helpDeskEmailSentSuccess(helpDeskEmail) {
  return {type: types.HELP_DESK_EMAIL_SENT_SUCCESS, helpDeskEmail};
}

export function sendHelpDeskInformation(formData) {
  return function (dispatch) {
    dispatch(startAjaxCall());
    return HelpDeskApi.sendHelpDeskInformation(formData).then(response => {
        if(response && response.success) {
          dispatch(helpDeskEmailSentSuccess(response));
          return response;
        } else {
          dispatch(startAjaxCallError("Your question or comment could not be processed right now. Please try again at a later time."));
          return (new Error("Your question or comment could not be processed right now. Please try again at a later time."));
        }
      }).catch(error => {
      dispatch(startAjaxCallError(error.message));
      throw error;
    });
  };
}



/** WEBPACK FOOTER **
 ** ./src/actions/helpDeskActions.js
 **/